export enum RegisterFlowStepsEnum {
    'EMPTY' = 'EMPTY',
    'REWARD' = 'REWARD',
    'LOGIN_BUTTONS' = 'LOGIN_BUTTONS',
    'SUBSCRIBE' = 'SUBSCRIBE',
    'PREFERENCES' = 'PREFERENCES',
    'WELCOME' = 'WELCOME',
    'REWARD_CONGRATS' = 'REWARD_CONGRATS',
    'FINISHED' = 'FINISHED'
}